import React, { Component } from 'react';
import { Form, Input, Button, Card, Tag } from 'antd';
import { UserOutlined, PhoneOutlined } from '@ant-design/icons';
import firebase from "firebase";

import ImageUploader from './AddImage';
import Header from '../common/Header';
import Status from '../common/Status';

class AddUser extends Component {
  state = {
    name: '',
    phoneNumber: '',
    imageUrl: '',
    loading: false,
    type: '',
    message: '',
    showAlert: false,
    showFilename: false,
  }

  onChangeInput = (val) => (event) => {
    this.setState({
      [val]: event.target.value,
      showAlert: false,
      type: '',
      message: '',
    });
  }

  onAddUser = () => {
    const { name, phoneNumber, imageUrl } = this.state
    const [ registrationDate ] = new Date().toLocaleString().split(',')

    if(name && phoneNumber && imageUrl) {
      firebase.database().ref(`/${phoneNumber}`).set({
        name,
        phoneNumber,
        imageUrl,
        registrationDate,
      }).then(() => {
        this.setState({
          name: '',
          phoneNumber: '',
          imageUrl: '',
          showAlert: true,
          showFilename: false,
          type: 'success',
          message: 'User added successfully',
        });
      })

    } else {
      this.setState({
        showAlert: true,
        type: 'warning',
        message: 'All fields required'
      });
    }
  }

  onUploadPicture = (pictureConfig) => {
    const { type, message, imageUrl, filename } = pictureConfig
    if(type === 'success') {
      this.setState({ type, imageUrl, filename, showFilename: true });
    } else {
      this.setState({ showAlert: true, type, message });
    }
  }

  renderFileName = () => {
    const { filename, imageUrl } = this.state
    return (
      <div className='selected-file-tag'>
        <Tag color="blue" >
          <span className='selected-file'>SELECTED FILE:</span>
          <a href={imageUrl} target="_blank" rel="noreferrer" className='selected-file-name'>{filename}</a>
        </Tag>
      </div>
    )
  }

  renderAddUserForm = () => {
    const { name, phoneNumber } = this.state

    return (
      <Form
        name="normal_login"
        className="add-user-form"
        initialValues={{ remember: true }}
        onFinish={this.onFinish}
      >
        <Header title="ADD USER"/>
        <Input
          value={name}
          prefix={<UserOutlined className="site-form-item-icon" />}
          placeholder="Enter Name"
          onChange={this.onChangeInput('name')}
          className='input-margin'
        />

        <Input
          prefix={<PhoneOutlined className="site-form-item-icon" />}
          type="number"
          placeholder="Enter Mobile Number"
          onChange={this.onChangeInput('phoneNumber')}
          value={phoneNumber}
          className='input-margin margin-bottom'
        />

        <ImageUploader onUploadPicture={this.onUploadPicture} avatar='' phoneNumber={this.state.phoneNumber} />

        {this.state.showFilename && this.renderFileName()}
        <Button type="primary" className='input-margin' onClick={this.onAddUser}> Create </Button>
      </Form>
    )
  }

  render() {
    const { type, message, showAlert } = this.state

    return (
      <div className='add-user-container'>
        <Card style={{ textAlign: 'center', paddingTop: '30px' }} >
          {this.renderAddUserForm()}
        </Card>
        {showAlert && <Status type={type} message={message} />}
      </div>
    );
  }
}
 
export default AddUser;